// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInYears as fn } from "../differenceInYears.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInYears = convertToFP(fn, 2);

// Fallback for modularized imports:
export default differenceInYears;
